import { useFormContext } from "react-hook-form";
import { Input, Textarea } from "rizzui";
import cn from "@/utils/class-names";
import FormGroup from "@/app/shared/form-group";
import FileInput from "./file-input";
import { HOST_API_URL } from "config";
import { Partner } from "@/types"; // Update import to Partner type

interface FormPartnerProps {
    className?: string;
}

export default function FormPartner({
    className,
}: FormPartnerProps) {
    const {
        register,
        formState: { errors },
        setValue,
        watch, // Add this to watch form values
    } = useFormContext<Partner>(); // Update the type here

    const formData = watch(); // Add this to get form data

    return (
        <FormGroup
            title="Partner"
            description="Enter the Partner information"
            className={cn(className)}
        >
            <Input
                label="Name"
                labelClassName="font-medium text-gray-900"
                placeholder="Name"
                {...register("name")}
                error={errors.name?.message as string}
            />

            <Input
                label="Sub Title"
                labelClassName="font-medium text-gray-900"
                placeholder="Sub Title"
                {...register("subTitle")}
                error={errors.subTitle?.message as string}
            />

            <Textarea
                label="Description"
                labelClassName="font-medium text-gray-900"
                rows={5}
                placeholder="Description"
                {...register("description")}
                error={errors.description?.message as string}
            />

            <FileInput
                label="Image"
                onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            // @ts-ignore
                            setValue("image", e.target.result);
                        };
                        reader.readAsDataURL(file);
                    }
                }}
            />
            <div
                className={cn(
                    "grid gap-6 @2xl:grid-cols-2 @3xl:gap-10 border border-muted rounded px-3 py-5",
                )}
            >
                <img
                    src={
                        HOST_API_URL.replace("api", "") +
                            "/" +
                            formData?.image
                                ?.replace("wwwroot\\", "")
                                .replace(/\\/g, "/") || "image"
                    }
                    alt={
                        formData?.image
                            ?.replace("wwwroot\\", "")
                            .replace(/\\/g, "/") || "image"
                    }
                    className="w-full h-auto"
                    width={200}
                    height={200}
                />
            </div>
        </FormGroup>
    );
}
